<script>
export default {
    name: 'CalendarViewSelector',

    props: {
        viewComponents: {
            type: Array,
            required: true
        },
        currentView: {
            type: String,
            required: true
        },
        hideShowFilters: {
            type: Boolean,
            required: true
        }
    },

    methods: {
        handleClick(item) {
            if ( item.component !== this.currentView ) {
                this.$emit('change-view', item.component)
            }
        },
        scrollTop() {
            this.$scrollTo(document.body)
        }
    },
}
</script>

<template>
    <div
        id="view-selector"
        class="container-fluid"
    >
        <div class="container pt-3 pt-sm-5 pb-3">
            <div class="d-flex justify-content-between align-items-end">
                <div class="d-flex align-items-end view-selector text-selection-none">
                    <button
                        v-for="(item, idx) in viewComponents"
                        :key="idx"
                        class="text-uppercase view-item no-btn"
                        :class="{
                            'active-view': item.component === currentView,
                            'mx-3': idx,
                            'mr-3': !idx
                        }"
                        tabindex="0"
                        @click="handleClick(item)"
                    >
                        {{ item.title }}
                    </button>
                </div>
                <div :class="{ 'd-none': hideShowFilters }">
                    <div class="d-none d-sm-block">
                        <a
                            href="#"
                            class="btn btn-outline-primary"
                            @click.prevent="scrollTop()"
                        >
                            {{ __('Filters / Search') }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "./resources/sass/_variables.scss";
@import 'bootstrap/scss/_mixins.scss';

#view-selector {
    button {
        color: #5779a1;
    }
}

.btn.btn-outline-primary {
    font-size: 12px;
    font-weight: normal;

    &:focus {
        color: $zh-blue;
    }
}
</style>
